import { Box } from "@mui/material";
import UnpaidMembershipUpsell from "components/member/UnpaidMembershipUpsell";
import WelcomeHeader from "components/member/home/WelcomeHeader";
import TaskList from "components/member/home/TaskList";
import AddTask from "components/member/home/AddTask";
import FlexBox from "components/common/FlexBox";
import UpcomingVideoCalls from "components/common/UpcomingVideoCalls";
import FeatureSuggestionsModule from "components/member/FeatureSuggestionsModule";
import FutureAdvisorInfo from "components/member/home/FutureAdvisorInfo";
import TaskDiscovery from "components/member/home/TaskDiscovery";
import { HomeLayoutProps } from "./types";

export default ({
  data,
  loading,
  currentUser,
  showAnimations,
  isDesktop,
  productPrompts,
  handleDismissFeatureSuggestions,
}: HomeLayoutProps) => {
  return (
    <Box sx={{ alignSelf: "center", maxWidth: "1000px", width: "100%" }}>
      <Box
        sx={{
          display: isDesktop ? "grid" : "flex",
          flexDirection: !isDesktop ? "column" : "",
          gridTemplateColumns: {
            sm: "1fr",
            md: "40% 60%",
          },
          gap: "24px",
        }}
      >
        <Box sx={{ gridColumn: "1 / -1" }}>
          <WelcomeHeader user={currentUser} />
          <UpcomingVideoCalls family={data?.family!} />
        </Box>

        <Box sx={{ gridColumn: "1 / -1" }}>
          <UnpaidMembershipUpsell />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: "24px",
          }}
        >
          <FlexBox
            variant="contained"
            direction="column"
            justifyContent="space-between"
          >
            <FutureAdvisorInfo />
          </FlexBox>
          <FlexBox variant="contained" direction="column" flex={0}>
            <AddTask family={data?.family!} />
          </FlexBox>
        </Box>

        <FlexBox
          variant="contained"
          direction="column"
          enableHeightAnimation={true}
          animationDuration="1.5s"
          maxHeight={showAnimations ? "1000px" : "420px"}
        >
          <TaskList
            tasks={data?.activeTasks || []}
            loading={loading || !data}
          />
        </FlexBox>

        {productPrompts?.featureSuggestionsDismissed !== "dismissed" && (
          <Box sx={{ gridColumn: "1 / -1" }}>
            <FeatureSuggestionsModule
              onDismiss={handleDismissFeatureSuggestions}
            />
          </Box>
        )}

        <FlexBox
          direction="column"
          enableHeightAnimation={true}
          animationDuration="1.5s"
          maxHeight={showAnimations ? "1000px" : "420px"}
          sx={{ gridColumn: "1 / -1" }}
        >
          <TaskDiscovery />
        </FlexBox>
      </Box>
    </Box>
  );
};
